import { flex, mt } from '@openeducation/oe-it-components';
import type { FeedbackResponseDTO } from '@openeducation/oe-it-services';
import React from 'react';
import { View } from 'react-native';

import { PCFeedbackCard } from '../pc-feedback-card/pc-feedback-card';
import { PCFeedbackEmptyCard } from '../pc-feedback-empty-card/pc-feedback-empty-card';

export interface PCFeedbackPanelProps {
  liveClassFeedbacks?: FeedbackResponseDTO[];
}

export const PCFeedbackPanel = ({
  liveClassFeedbacks,
}: PCFeedbackPanelProps) => {
  return (
    <View
      style={[mt(56), flex('justify-content-center', 'align-items-center')]}
    >
      {liveClassFeedbacks && liveClassFeedbacks.length > 0 ? (
        <PCFeedbackCard feedbacks={liveClassFeedbacks} />
      ) : (
        <PCFeedbackEmptyCard />
      )}
    </View>
  );
};
